import React from "react";
import { Loader2, Inbox, TriangleAlert, Hammer } from "lucide-react";

export const LoadingState = ({ label = "Loading…" }) => (
  <div data-testid="loading-state" className="flex items-center gap-3 text-slate-500 text-sm py-10 justify-center">
    <Loader2 size={18} className="animate-spin text-[#b3122a]" /> {label}
  </div>
);

export const EmptyState = ({ title = "Not available", detail = "No source data exists for this section." }) => (
  <div data-testid="empty-state" className="flex flex-col items-center gap-2 py-10 text-center">
    <Inbox size={22} className="text-slate-300" />
    <div className="text-sm font-semibold text-slate-600">{title}</div>
    <div className="text-xs text-slate-400 max-w-sm">{detail}</div>
  </div>
);

export const ErrorState = ({ message = "Something went wrong.", onRetry }) => (
  <div data-testid="error-state" className="flex flex-col items-center gap-2 py-10 text-center">
    <TriangleAlert size={22} className="text-[#b3122a]" />
    <div className="text-sm font-semibold text-slate-700">Could not load data</div>
    <div className="text-xs text-slate-500 max-w-md">{message}</div>
    {onRetry && (
      <button data-testid="error-retry-btn" onClick={onRetry}
        className="mt-2 text-xs font-bold uppercase tracking-wider text-[#b3122a] border border-[#b3122a]/30 rounded px-3 py-1.5 hover:bg-[#b3122a] hover:text-white transition-colors">
        Retry
      </button>
    )}
  </div>
);

export const BuildPlaceholder = ({ title, build, description }) => (
  <div data-testid="build-placeholder" className="min-h-[70vh] flex items-center justify-center p-8">
    <div className="max-w-md w-full bg-white border border-slate-200 rounded-sm p-10 text-center">
      <Hammer size={26} className="mx-auto text-slate-300" />
      <div className="mt-4 font-['Playfair_Display'] text-2xl text-slate-900">{title}</div>
      <div className="mt-2 text-sm text-slate-500">{description}</div>
      <div className="mt-6 inline-flex items-center gap-2 bg-slate-50 border border-slate-200 rounded px-3 py-1.5 text-[11px] font-bold uppercase tracking-[0.12em] text-slate-500">
        Arrives in Build {build}
      </div>
    </div>
  </div>
);
